module.exports = __webpack_public_path__ + "static/media/erupting.52f588f4.mp4";